import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Testimonials from "../shared/testimonials";
import Faq from "./faq";
import ServiceHero from "./hero";
import OurApproach from "./our-approach";
import OurOfferings from "./our-offerings";
import Services from "./services";
import ServiceCTA from "./cta";
import { serviceDummyData } from "../../data/service-data/serviceData";

const ServiceDetail = () => {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (slug) {
      const serviceData = serviceDummyData.find((item) => item.slug === slug);
      if (serviceData) {
        setData(serviceData);
      }
    } else {
    }
  }, [slug]);

  if (!data) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <ServiceHero key={data.slug} data={data} />
      <OurOfferings
        data={data.subServices}
        serviceTitle={data.title}
        serviceOverview={data.serviceOverview}
      />
      <OurApproach
        data={data.ourApproach}
        hasSubServices={data.subServices?.length > 0}
        serviceTitle={data.title}
      />
      <Services data={data.keyBenefits} title={data?.title} />
      {/* <Testimonials description={data.testimonials} /> */}
      <ServiceCTA
        imageSrc={data.CTA?.img}
        text={data.CTA?.description}
        onButtonClick={() => navigate("/contact")}
      />
      <Faq data={data.FAQ} />
    </>
  );
};

export default ServiceDetail;
